module.exports = __webpack_public_path__ + "media/images/alert_icon-59563bca.svg";